module.exports = __webpack_public_path__ + "img/suunto-bg-logo.8802386c.png";